module.exports = __webpack_public_path__ + "img/people1.88ab7e5b.png";